import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_r4y8n8tck3: FaireCollectionEntity = {
  token: "pbc_r4y8n8tck3",
  type: "collection",
  name: "JUST IN",
  heroImageUrl:
    "https://cdn.faire.com/fastly/84bf9c388f22fb209118090a7ffa9aad3592c7e2508925e14e799ecde6764d2e.jpeg",
  itemCount: 78,
  brandToken: "b_q8gu9by5sv",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:48:55.093Z",
    importedBy: "entity-db-import-collections",
  },
};
